import type { GroupMode, State } from "./types";

export const normalizeArray = (value: unknown): string[] => {
  if (Array.isArray(value)) return value.map(String).filter(Boolean);
  if (value === undefined || value === null || value === "") return [];
  return [String(value)];
};

export const isFixturesBoard = (state: State): boolean =>
  ["fixtures", "results"].includes(String(state.contract?.variant || state.contract?.feature || ""));

export const isResultsBoard = (state: State): boolean =>
  state.contract?.variant === "results" || state.contract?.feature === "results";

export const dataGroupMode = (state: State): GroupMode => state.groupMode;
